import { useState, useEffect } from "react";
import SameTimeAllWeek from "./SameTime";
import DeliverToggle from "../../../components/toggleButton/DeliverToggle";
import "../../../styles/stores/storeProfile/openingHours.css";
import DifferentTimeAllWeek from "./DiferentTImeAllWeek";

export const TimeSet = ({ id, updateOpenTimeState, openTimeState, fullDayOnpen, day, color }) => {
  const [isClosed, setIsClosed] = useState(false);
  const [openTime, setOpenTime] = useState();
  const [closeTime, setCloseTime] = useState();

  useEffect(() => {
    if (openTime && closeTime) {
      updateOpenTimeState({ ...openTimeState, [fullDayOnpen]: { from: openTime, to: closeTime } });
    }
  }, [openTime, closeTime]);

  const hangleClose = (e) => {
    setIsClosed(true);
    setOpenTime("");
    updateOpenTimeState({ ...openTimeState, [fullDayOnpen]: { from: "closed", to: "closed" } });
    let divNode = document.getElementById(id);
    console.log(divNode);
    Array.from(divNode.children).forEach((child) => {
      child.disabled = true;
    });
  };

  const handleOpen = (e) => {
    setIsClosed(false);
    setOpenTime("");
    updateOpenTimeState({ ...openTimeState, [fullDayOnpen]: { from: "", to: "" } });
    let divNode = document.getElementById(id);
    console.log(divNode);
    Array.from(divNode.children).forEach((child) => {
      child.disabled = false;
    });
  };

  return (
    <>
      <div>
        <p style={{ backgroundColor: isClosed ? "#cecece" : color }}>{day}</p>
        <div id={id} className='generalTimeOpenhrs'>
          <input value={openTime} onChange={(e) => setOpenTime(e.target.value)} type='time' name='' id='' />
          -
          <input value={closeTime} onChange={(e) => setCloseTime(e.target.value)} type='time' name='' id='' />
        </div>
        {isClosed ? (
          <p style={{ color: "#54E346" }} onClick={(e) => handleOpen(e)}>
            Open
          </p>
        ) : (
          <p onClick={(e) => hangleClose(e)}>Close</p>
        )}
      </div>
    </>
  );
};

const OpeningHours = ({ store, closeModal }) => {
  const [sameTimeAllWeek, setSameTimeAllWeek] = useState(true);

  useEffect(() => {
    console.log(sameTimeAllWeek);
  }, [sameTimeAllWeek]);

  return (
    <>
      <div
        onClick={() => {
          closeModal(false);
        }}
        className='openingHoursWrapper12'
      >
        <div onClick={(e) => e.stopPropagation()} className='openingHoursDiv132'>
          <h3>
            Select Opening Hours for {store.storeName} {store.storeName.toLowerCase().includes("store") ? "" : "store"}
          </h3>
          <div className='storeControlOpening'>
            <p>Same time every day including weekends</p>
            <DeliverToggle toggleValue={sameTimeAllWeek} updatetoggle={setSameTimeAllWeek} />
          </div>
          {sameTimeAllWeek && <SameTimeAllWeek store={store} closeModal={closeModal} />}
          {!sameTimeAllWeek && <DifferentTimeAllWeek store={store} closeModal={closeModal} />}
        </div>
      </div>
    </>
  );
};

export default OpeningHours;
